



jQuery(function($) {
     var path = window.location.href; // because the 'href' property of the DOM element is the absolute path
     $('.sidebar-content ul a').each(function() {
      if (this.href === path) {
       $(this).addClass('activedside');
      }
     });
    });



jQuery(document).ready(function(){
  jQuery('.level-top a').attr('target', '_blank');
});


jQuery(document).ready(function(){
  jQuery('.menu-item-go-to-main-site a').attr('target', '_blank');
});


// Countdown target date
var countDownDate = new Date("2024-11-05T23:59:59").getTime();

// Update countdown every 1 second
var x = setInterval(function() {
    var now = new Date().getTime();
    var distance = countDownDate - now;

    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Check if elements exist before updating
    if (document.getElementById("days")) {
        document.getElementById("days").innerHTML = days;
        document.getElementById("hours").innerHTML = hours;
        document.getElementById("minutes").innerHTML = minutes;
        document.getElementById("seconds").innerHTML = seconds;
    }

    // Update header countdown if elements are present
    if (document.getElementById("header-days")) {
        document.getElementById("header-days").innerHTML = days;
        document.getElementById("header-hours").innerHTML = hours;
        document.getElementById("header-minutes").innerHTML = minutes;
        document.getElementById("header-seconds").innerHTML = seconds;
    }

    // If countdown is over
    if (distance < 0) {
        clearInterval(x);
        if (document.getElementById("countdown")) {
            document.getElementById("countdown").innerHTML = "SALE EXPIRED";
        }
        if (document.getElementById("header-countdown")) {
            document.getElementById("header-countdown").innerHTML = "SALE EXPIRED";
        }
    }
}, 1000);


document.addEventListener("DOMContentLoaded", function () {
    const discountText = document.getElementById("discount-text");
    const variantSelector = document.querySelector("[name='id']");

    if (!variantSelector || !discountText) return;

    function updateDiscount() {
        const variantId = variantSelector.value;
        const variant = window.productVariants.find(v => v.id == variantId);

        if (variant && variant.compare_at_price > variant.price) {
            const discount = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            discountText.textContent = `Save: ${discount}%`;
        } else {
            discountText.textContent = ""; // No discount case
        }
    }

    // Update discount on page load
    updateDiscount();

    // Shopify handles variant selection through a form event
    document.querySelector("form[action*='/cart/add']").addEventListener("change", updateDiscount);
});

